const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Dashboard de estadísticas y datos',
  PAGE_DESCRIPTION:
    'Esta es la página inicial del sistema. Desde aquí puedes ver estadísticas útiles del almacén en el que se encuentre. Cuenta con algunas gráficas que te ayudarán a obtener datos del estatus del almacén.'
};

export default HELPER_TEXTS;
